import { render, staticRenderFns } from "./FMessage.vue?vue&type=template&id=660dda38&"
import script from "./FMessage.vue?vue&type=script&lang=js&"
export * from "./FMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports